/*       */

import { gql } from '@apollo/client';

export default type => gql`
    mutation unsubscribeEntityChatMutation($id: ID!, $userId: String!) {
        chatId: ${type === 'class' ? 'classChatUnsubscribe' : 'entityChatUnsubscribe'}(id: $id, userId: $userId${type === 'class' ? '' : `, type: "${type}"`})
    }`;
